// helper function, because casing varies
export function findBalance(token, balances) {
    const tok = token.toLowerCase();
    for (const [t, b] of Object.entries(balances)) {
        if (tok === t.toLowerCase()) {
            return BigInt(b);
        }
    }
    return 1n;
}
